import {
	Message
} from 'element-ui'

//全局配置elementui的message弹窗，有关闭按钮
function createMessage(type) {
	return function(options) {
		if (typeof options === 'string') {
			options = {
				message: options
			}
		}
		return Message({
			type,
			showClose: true,
			...options
		})
	}
}

export default {
	install(Vue) {
		Vue.prototype.$message = function(options) {
			if (typeof options === 'string') {
				options = {
					message: options
				}
			}
			return Message({
				showClose: true,
				...options
			})
		}

		// 快捷方法也封装一遍
		Vue.prototype.$message.success = createMessage('success')
		Vue.prototype.$message.warning = createMessage('warning')
		Vue.prototype.$message.info = createMessage('info')
		Vue.prototype.$message.error = createMessage('error')
	}
}
